<template>
  <div class="fireControl">
  	<div class="topDisplay">
  		<div class="rightList" :style="{width: (showMap ? '25%': '100%')}">
  			<div class="totalNum">
  				<a-tabs :activeKey="currentKey" @change="callback" type="card">
				    <a-tab-pane tab="全部" key="-1"></a-tab-pane>
				    <a-tab-pane tab="完好" key="0"></a-tab-pane>
				    <a-tab-pane tab="故障" key="1"></a-tab-pane>
				    <a-tab-pane tab="缺失" key="2"></a-tab-pane>
				    <a-button slot="tabBarExtraContent" @click="reset">重置</a-button>
				  </a-tabs>
  				<div class="numTitle">{{buildingName}}</div>
  				<!--<div class="specificNum">4699个</div>-->
  				<div class="divideName">
  					<div @click="popDrawer(item)" v-for="(item,index) in fireControlData">{{item.typename}}：<span>{{item.facilitycount}}</span></div>
  					<p class="noData" v-if="fireControlData.length==0">暂无物品</p>
  				</div>
  			</div>
        <!-- <div class="totalNum1">
          <div class="numTitle">灭火器待维护信息</div>
          <div class="lineQuery">
            <a-date-picker style="width:150px" placeholder="提醒日期" :allowClear="false"  v-model="searchForm.reminderTime" format="YYYY-MM-DD" @change="searchList(1)" />
          	<a-button @click="resetList">重置</a-button>
            <a-button type="primary" style="float: right;margin-left: 5px;" @click="exportExcel">导出</a-button>
          </div>
        	<CustomPage  :columns="columns" :url="url" :scroll="{y: 180 }"  ref="table">
        	</CustomPage>
        </div> -->
  		</div>
  		<div v-if="showMap" id="container" style="width:74%;height:100%;"></div>
  	</div>
  	<a-drawer title="设施列表" @close="onClose" :visible="visible" width="88%" >
      <FireFacility ref="facilityId"/>
    </a-drawer>
  </div>
</template>

<script>
		import FireFacility from "./firefacility/FireFacilityMap.vue"
    import houseModel from "./MapDate.js"
    import echarts from 'echarts'
    import CustomPage from '@/views/common/CustomPage'
    import moment from 'moment';

    const table = {
    	searchForm: {
    		reminderTime: moment(),
    		isMaintain: '1'
    	},
    	url: 'facility/page',
    	columns: [
    		{
    			title: '设施编号',
    			align: 'center',
    			dataIndex: 'facilityNum'
    		},
    		{
    			title: '设施类型',
    			align: 'center',
    			dataIndex: 'facilityTypeName'
    		},

    		{
    			title: '上次维保时间',
    			align: 'center',
    			dataIndex: 'checkTime',
    			customRender: (text, row, index) => {
    				return text ? text.slice(0, 10) : ' -- '
    			}
    		},


    	]
    }
export default {
	components: {FireFacility,CustomPage},
	props:{
		showMap:{
			type: Boolean,
			default: true
		}
	},
  data() {
    return {
    	data:[],
      multilaterals:[],//绘制多边形房子
    	//抽屉
			visible:false,
    	//地图
    	map:null,
    	marker:[],
    	stationIcon: require('@/../static/img/cll-linemap-item.png'),
			stationIconOn: require('@/../static/img/cll-linemap-item_1.png'),
			RepairData:[], // 数据对象
      buildingId:null,
      status:null,
      fireControlData:[],
      buildingName:'全部',
      currentKey:'-1',
      ...table,
      loading: false,
      jumpNotification: true,
    }
  },
  mounted(){
  	this.createMap();
    this.search()
    this.getMaintenanceMsg()
  },
  methods:{
  	callback(key){
  		this.currentKey=key;
  		if(key==-1){
  			this.status=null;
  		}else{
  			this.status=key;
  		}
  		this.search();
      this.searchList();

  	},
  	reset(){
  		this.currentKey='-1';
  		this.buildingId=null;
  		this.status=null;
  		this.buildingName='全部';
  		this.search();
  	},
    search(){
      let url = 'facility/countAllType';
      if(this.buildingId){
        url = 'facility/countList';
      }
      this.$get(url,{buildingId:this.buildingId,status:this.status}).then(r => {
      	this.fireControlData=r.data;
      })
    },
    getMaintenanceMsg() {
    	var that = this;
    	let params = {
    		pageNum: 1,
    		pageSize: 10,
        isMaintain: '1',
        reminderTimeStr: moment(this.searchForm.reminderTime).format('YYYY-MM-DD').toString()
    	};
    	this.$get('facility/page', params).then(res => {
    		if (res.data.total > 0) {
    			that.$notification.open({
    				message: '待维护设备消息',
    				description: '有' + res.data.total + '个灭火器设施待维护',
    				placement: 'bottomRight',
    				duration: 6,
    				icon: <a-icon type="bell" style="color:red;" theme="filled" />,
    				style: {
    					cursor: 'pointer'
    				},
    				onClick() {
    					if (that.jumpNotification == true) {
    						that.$router.push({
    							path: 'maintenanceList'
    						});
    						that.jumpNotification = false;
    					}
    				},
    				onClose(e) {
    					that.jumpNotification = false;
    				}
    			});
    		}
    	});
    },
    searchList(pageNum) {
    	this.loading = true
    	this.searchForm.pageNum = 1; // 初始化的当前页
      this.searchForm.reminderTimeStr = moment(this.searchForm.reminderTime).format('YYYY-MM-DD').toString();
    	this.$refs.table.handleList(this.searchForm)
    	this.loading = false
    },
    resetList(){
    	this.searchForm.reminderTime = moment()
    	this.searchList();
    },
    exportExcel () {
      this.$export('facility/export',{...this.searchForm})
    },
  	createMap(){
  			var that=this;
	  		that.map=new AMap.Map('container', {
	        resizeEnable: true, //是否监控地图容器尺寸变化
	        zoom:18, //初始化地图层级
	        labelzIndex:110,//地图标注显示顺序
	        zooms:[15,18],
	        center: [114.39316,30.48668] //初始化地图中心点
	    });
	    //画房
        for(var i=0,multilateral,len=houseModel.length;i<len;i++){
        	multilateral=new AMap.Polygon({
                path: houseModel[i].coordinate,
                fillColor: '#EFF1ED',//填充
                // strokeColor: "#DEE3E0",//边框
                strokeColor: "#EFF1ED",//边框
                strokeWeight: 5
            })
        		that.multilaterals.push(multilateral)
        		that.multilaterals[i].setMap(that.map);
        		that.multilaterals[i].on('click',function(e){
        			// console.log(e)
        		})
        }
        //画点
	   	that.$get('building/list').then(r => {
	      AMapUI.loadUI(['overlay/SimpleMarker'], function(SimpleMarker) {
	   			for (var i = 0, len = r.data.length; i < len; i++) {
   			 		that.marker.push(
   			 			new SimpleMarker({
	   			 			iconTheme:'default',
	   			 			iconStyle:r.data[i].rate>=0.95?'green':r.data[i].rate>=0.80?'orange':'red',
	   			 			map: that.map,
	            	position: [r.data[i].buildingLongitude,r.data[i].buildingLatitude],
	             	extData:{
	             		index:i,
	             		id:r.data[i].id
	             	}
   			 			})
   			 		)
   			 		that.map.setFitView(that.marker[0]);
   			 		that.marker[i].on('mouseover',function(e){
   			 			var data=e.target.De.extData.index;
   			 			that.marker[data].setLabel({
   			 				content: r.data[data].buildingName,
                offset: new AMap.Pixel(17, 45)
   			 			})
						})
   			 		that.marker[i].on('mouseout',function(e){
   			 			var data=e.target.De.extData.index;
   			 			that.marker[data].setLabel({
   			 				content: null
   			 			})
						})
     			 	that.marker[i].on('click',function(e){
     			 		that.buildingName=r.data[e.target.De.extData.index].buildingName;
							var id=e.target.De.extData.id
							that.buildingId = id
              that.search()
						})
	   			}
	   		})
	    })
  	},
  	onClose(){
  		this.visible=false;
  	},
  	popDrawer(item){
  		var that=this,data=item;
  		that.visible=true;
  		data.buildingId=that.buildingId;
  		data.currentKey=that.currentKey=='-1'?null:this.currentKey;
  		setTimeout(function(){
		    that.$refs.facilityId.equipment(data)
		  },0)
  	}
  }
}
</script>

<style lang="less" scoped>
  .fireControl{
    width: 100%;

    .topDisplay{
    	height:80vh;
    	.rightList{
    		width:25%;
    		height:100%;
    		float: right;
    		.totalNum{
    			/*height:40%;*/
    			border:1px solid #eee;
    			padding:10px;
    			.numTitle{
    				text-align: center;
    				font-size: 20px;
    				padding: 5px 0px;
    				font-weight: 600;
    			}
    			.divideName{
    				display: flex;
    				flex-flow: wrap;
    				cursor: pointer;
    				div{
    					width: 50%;
    					font-size: 16px;
    					padding: 15px 0;
    					span{
    						color: #0BA4DB;
    						font-size: 17px;
    					}
    				}
    				.noData{
    					width: 100%;
    					color: #aaa;
    					text-align: center;
    					margin-top: 15px;
    				}
    			}
    		}
        .totalNum1{
        	/*height:40%;*/
          margin-top: 10px;
        	border:1px solid #eee;
        	padding:10px;
          .lineQuery {
          			margin: 10px 0;
          		}
        	.numTitle{
        		text-align: center;
            color: red;
        		font-size: 20px;
        		padding: 5px 0px;
        		font-weight: 600;
        	}
        	.divideName{
        		display: flex;
        		flex-flow: wrap;
        		cursor: pointer;
        		div{
        			width: 50%;
        			font-size: 16px;
        			padding: 15px 0;
        			span{
        				color: #0BA4DB;
        				font-size: 17px;
        			}
        		}
        		.noData{
        			width: 100%;
        			color: #aaa;
        			text-align: center;
        			margin-top: 15px;
        		}
        	}
        }
    		.needRepair{
    			height:58%;
    			border:1px solid #eee;
    			margin-top: 2%;
    			overflow: auto;
    		}
    	}
    }

    .bottomDisplay{
    	margin-top: 1vh;
    	height:30vh;
    	display: flex;
    	justify-content:space-between;
    	.leftList{
    		width:25%;
    	}
    	.middleList{
    		width:48%;
    		.titleH2{
    			padding:5px 10px;
    		}
    	}
    	.pictograph{
    		width:25%;
    		padding:10px;
    		.ChartCensus{
    			height:50%;
    			display: flex;
    			flex-flow: wrap;
    		}
    		.ChartCensus>div{
    			width: 50%;
    			display: flex;
    			justify-content: space-around;
    			align-items: center;
    		}
    	}
    }
    .bottomDisplay>div{
    	height:100%;
    	border:1px solid #eee;
    	padding:5px;
    	overflow: auto;
    }
  }
  /deep/.amap-marker-label{
  	border: 1px solid #595959;
  	transform:translateX(-50%)
  }
</style>



// WEBPACK FOOTER //
// src/views/web/Weather.vue